const items = (that) => [
    {
        get enabled() {
            return that?.checkPermission("chatbot.stories.view");
        },
        key: "stories",
        group: that?.$t("chatbotv2.ChatbotScenarioList") || "",
        label: that?.$t("chatbotv2.Scenario") || "",
        icon: {
            type: "material-icons",
            name: "book",
        },
    },
    {
        get enabled() {
            return that?.checkPermission("chatbot.templates.view");
        },
        key: "templates",
        group: that?.$t("chatbotv2.ChatbotScenarioList") || "",
        label: that?.$t("chatbotv2.templates") || "",
        icon: {
            type: "material-icons",
            name: "view_timeline",
        },
    },
    {
        get enabled() {
            return that?.checkPermission("chatbot.aitemplates.view");
        },
        key: "ai/templates",
        group: that?.$t("chatbotv2.ChatbotScenarioList") || "",
        label: that?.$t("chatbotv2.templatesFromTheIndustry") || "",
        icon: {
            type: "material-icons",
            name: "psychology",
        },
    },
    {
        get enabled() {
            return that?.checkPermission("chatbot.integrations.view");
        },
        key: "integrations",
        group: that?.$t("chatbotv2.ChatbotScenarioList") || "",
        label: that?.$t("chatbotv2.integrations") || "",
        icon: {
            type: "material-icons",
            name: "key",
        },
    },
    {
        enabled: false,
        key: "integrations/webhook",
        parentKey: "integrations",
        group: that?.$t("chatbotv2.ChatbotScenarioList") || "",
        label: that?.$t("chatbotv2.integrations") || "",
        icon: {
            type: "material-icons",
            name: "history",
        },
    },
    {
        get enabled() {
            return that?.checkPermission("chatbot.archive.view");
        },
        key: "archive",
        group: that?.$t("chatbotv2.chatbotManagement") || "", // todo: translate
        label: that?.$t("chatbotv2.archive") || "",
        icon: {
            type: "material-icons",
            name: "history",
        },
    },
    // chatbot varlıklar düzeltilene kadar geçici süreliğine erişimi kaldırıldı
    // {
    //     get enabled() {
    //         return that?.checkPermission("chatbot.entities.view");
    //     },
    //     key: "entities",
    //     group: that?.$t("chatbotv2.chatbotManagement")  || "", // todo: translate
    //     label: that?.$t("chatbotv2.entities") || "",
    //     icon: {
    //         type: "material-icons",
    //         name: "dataset",
    //     },
    // },
    {
        get enabled() {
            return that?.checkPermission("chatbot.reports.view");
        },
        key: "reports/all-chats",
        group: that?.$t("chatbotv2.reports") || "",
        label: that?.$t("chatbotv2.allChats") || "",
        icon: {
            type: "material-icons",
            name: "chat_bubble",
        },
    },
    {
        get enabled() {
            return that?.checkPermission("chatbot.reports.view");
        },
        key: "reports/overall",
        group: that?.$t("chatbotv2.reports") || "",
        label: that?.$t("report.overall") || "Overall",
        icon: {
            type: "material-icons",
            name: "area_chart",
        },
    },
    {
        get enabled() {
            return that?.checkPermission("chatbot.reports.view");
        },
        key: "reports/busiest-period",
        group: that?.$t("chatbotv2.reports") || "",
        label: that?.$t("chatbotv2.busiestPeriod") || "",
        icon: {
            type: "material-icons",
            name: "analytics",
        },
    },
    {
        get enabled() {
            return that?.checkPermission("chatbot.reports.view");
        },
        key: "reports/rating-distribution",
        group: that?.$t("chatbotv2.reports") || "",
        label: that?.$t("chatbotv2.ratingDistribution") || "",
        icon: {
            type: "material-icons",
            name: "trending_up",
        },
    },
    {
        get enabled() {
            return that?.checkPermission("chatbot.reports.view");
        },
        key: "reports/popularity",
        group: that?.$t("chatbotv2.reports") || "",
        label: that?.$t("chatbotv2.popularity") || "",
        icon: {
            type: "material-icons",
            name: "hotel_class",
        },
    },
    {
        get enabled() {
            return that?.checkPermission("chatbot.training.view");
        },
        key: "training",
        group: that?.$t("chatbotv2.chatbotManagement")  || "", // todo: translate
        label: that?.$t("chatbotv2.training") || "",
        icon: {
            type: "material-icons",
            name: "school",
        },
    },
    {
        enabled: true,
        key: "user-segments",
        group: that?.$t("chatbotv2.chatbotManagement")  || "", // todo: translate
        label: that?.$t("chatbotv2.userSegments") || "",
        icon: {
            type: "material-icons",
            name: "segment",
        },
    },
    {
        get enabled() {
            return true;
        },
        key: "block-market",
        group: that?.$t("chatbotv2.chatbotManagement") || "",
        label: that?.$t("chatbotv2.blockMarket") || "Block Market",
        icon: {
            type: "material-icons",
            name: "store",
        },
    },
    {
        get enabled() {
            return true;
        },
        key: "sandbox",
        group: that?.$t("chatbotv2.ChatbotScenarioList") || "",
        label: "Çöp Kutusu",
        icon: {
            type: "material-icons",
            name: "delete",
        },
    }
];

export default items;
